const tabs = document.querySelectorAll('.locations');
const filterTabs = document.querySelectorAll('.filter-tabs');
const picture = document.querySelector('.tab-picture');
const aroundNeighborhoodSection = document.getElementById('around-neighborhood');
let markers = [];
let googleMap;
let markerCount = 0;
let currentTab;
let pinsize = screen.width > 767 ? 50 : 30;

const imageRoute = '/assets/img/';
let icons;

if(typeof google != 'undefined' && aroundNeighborhoodSection){

  const handlePinClick = (e) => {
    e.preventDefault();
    const pinID = e.currentTarget.getAttribute('data-id');
    setActivePin(pinID);
  }

  const setActivePin = (ID) => {
    const checkSelected = document.querySelector('.locations-item.selected');
    if(checkSelected) checkSelected.classList.remove('selected');
    document.querySelector(`.locations-item[data-id="${ID}"]`).classList.add('selected');

    markers[currentTab].forEach((item) => {
      if(item.ID == ID){
        item.marker.setIcon(icons.activePoint);
      } else {
        item.marker.setIcon(icons.point);
      }
    })
  }

  async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const target = document.getElementById("neighborhoodMap");

    let bounds = new google.maps.LatLngBounds();

    icons = {
      property: {
        url: imageRoute + 'MAA_logo-pin.svg',
        scaledSize: new google.maps.Size(pinsize, pinsize)
      },
      point: {
        url: imageRoute + 'pin-blue-large.svg',
        scaledSize: new google.maps.Size(pinsize, pinsize)
      },
      activePoint: {
        url: imageRoute + 'pin-orange-large.svg',
        scaledSize: new google.maps.Size(pinsize, pinsize)
      }
    }

    if (target) {
      googleMap = new Map(target, {
        center: {
          lat: Number(aroundNeighborhoodSection.dataset.propLat),
          lng: Number(aroundNeighborhoodSection.dataset.propLng),
        },
        zoom: 14,
      });

      tabs.forEach((tab) => {
        let selectedTab = false;
        let arrayName = tab.getAttribute('data-category');

        if(tab.classList.contains('selected')){
          currentTab = arrayName;
          selectedTab = true;
        }

        let tabMarkers = [];
        const tabItems = tab.querySelectorAll('.locations-item');
        tabItems.forEach((item) => {
          const ID = item.getAttribute('data-ID');
          const lat = item.getAttribute('data-lat');
          const lng = item.getAttribute('data-lng');
          const title = item.querySelector('.locations-item__name').innerText;
          let marker = createMarker(lat, lng, title, item);

          marker.addListener('click', () => {
            setActivePin(ID);
          })

          if(selectedTab){
            marker.setMap(googleMap);
            bounds.extend(marker.position);
          }

          item.addEventListener('click', handlePinClick);

          let tabMarker = { ID: ID, marker: marker };
          tabMarkers.push(tabMarker);
          markerCount++;
        })
        markers[arrayName] = tabMarkers;
      })

      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
     }

      if(googleMap && markers[currentTab].length > 0) googleMap.fitBounds(bounds);
    }
  }
  initMap();

  const createMarker = (lat, lng, title, tab) => {
    const itemLatLng = { lat: Number(lat), lng: Number(lng) };

    const marker = new google.maps.Marker({
      position: itemLatLng,
      map: null,
      title: title,
      icon: icons.point
    })
    return marker;
  }

  const handleTabClick = (e) => {
    e.preventDefault();

    currentTab = e.currentTarget.getAttribute('data-target');
    const tabTitle = e.currentTarget.innerText;
    const tabDescription = e.currentTarget.getAttribute('data-description');
    const img = e.currentTarget.getAttribute('data-image');
    const imgSmall = e.currentTarget.getAttribute('data-imageSmall');

    picture.innerHTML = `
      <source media="(min-width:768px)" srcset='${img}' alt='${currentTab}' />
      <img src='${imgSmall}' alt='${currentTab}' />
    `;   
    document.querySelector('.tab-title').innerText = tabTitle.toLowerCase();
    document.querySelector('.tab-description').innerText = tabDescription;
    document.querySelector('.filter-tabs.selected').classList.remove('selected');
    e.currentTarget.classList.add('selected');
    document.querySelector('.locations.selected').classList.remove('selected');
    const target = document.querySelector(`[data-category="${currentTab}"]`);
    target.classList.add('selected');
    
    const bounds = new google.maps.LatLngBounds();

    for (const [key, value] of Object.entries(markers)) {
      const showMarker = key == currentTab;
      value.forEach((item) => {
        if (showMarker) {
          item.marker.setMap(googleMap);
          bounds.extend(item.marker.position);
        } else {
          item.marker.setMap(null);
        }
      })
    }

    if (bounds.getNorthEast().equals(bounds.getSouthWest()) && markers[currentTab].length > 0) {
      var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
      var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);
    }

    if(googleMap) {
      if (markers[currentTab].length === 0) {
        googleMap.panTo({lat: Number(aroundNeighborhoodSection.dataset.propLat), lng: Number(aroundNeighborhoodSection.dataset.propLng)});
        googleMap.setZoom(14);
      } else {
        googleMap.fitBounds(bounds);
      }
    }
  }

  filterTabs.forEach((tab) => {
    tab.addEventListener('click', handleTabClick);
  })
}



// WEBPACK FOOTER //
// ./src/templates/components/around-neighborhood/around-neighborhood.js